import React, { useEffect, lazy } from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
type CaseStudyTag = {
  name: string;
};
type CaseStudy = {
  title: string;
  description: string;
  image: string;
  tags: CaseStudyTag[];
  gradient: string;
  slug: string;
};
export const CaseStudies = () => {
  const navigate = useNavigate();
  const caseStudies: CaseStudy[] = [{
    title: 'AI-Powered CX Feature',
    description: 'Complex module redefined with AI-driven insights and prototype in 2 weeks.',
    image: 'https://images.unsplash.com/photo-1581287053822-fd7bf4f4bfec?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80&fm=webp',
    tags: [{
      name: 'Senior PM'
    }, {
      name: 'AI Prototype'
    }, {
      name: 'AdTech / CX'
    }],
    gradient: 'from-amber-400 via-orange-500 to-amber-300',
    slug: 'cx-feature-revamp'
  }, {
    title: 'LLM Feedback App (0→1)',
    description: 'Voice/chat captures with AI analysis turned into actionable reviews in 3 weeks.',
    image: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80&fm=webp',
    tags: [{
      name: 'Senior PM'
    }, {
      name: 'AI Integration'
    }, {
      name: 'HR Tech'
    }],
    gradient: 'from-blue-600 via-indigo-500 to-purple-500',
    slug: 'ai-feedback-app'
  }, {
    title: 'ML Recommendation Engine',
    description: 'AI-powered platform with rapid prototyping and 30% engagement increase.',
    image: 'https://images.unsplash.com/photo-1460925895917-afdab827c52f?ixlib=rb-1.2.1&auto=format&fit=crop&w=1200&q=80&fm=webp',
    tags: [{
      name: 'Lead PM'
    }, {
      name: 'ML Algorithm'
    }, {
      name: 'E-commerce'
    }],
    gradient: 'from-orange-500 via-red-500 to-pink-500',
    slug: 'screening-platform-revamp'
  }];
  const handleCaseStudyClick = (slug: string) => {
    // Navigate to case study detail page
    navigate(`/case-study/${slug}`);
    // Scroll to top (this is also handled in the CaseStudyDetail component's useEffect)
    window.scrollTo(0, 0);
  };
  return <section id="case-studies" className="py-20 bg-background-light" data-id="element-158">
      <div className="container mx-auto px-4 md:px-6" data-id="element-159">
        <div className="text-center mb-12" data-id="element-160">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-161">Case Studies</h2>
          <p className="text-text-secondary max-w-2xl mx-auto" data-id="element-162">
            Explore how we've helped businesses achieve their product goals with
            our AI-powered product management expertise.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-163">
          {caseStudies.map((study, index) => <div key={index} onClick={() => handleCaseStudyClick(study.slug)} className={`group cursor-pointer overflow-hidden rounded-3xl bg-gradient-to-br ${study.gradient} p-6 pb-16 relative min-h-[500px] transition-all duration-300 hover:shadow-lg`} data-id="element-164">
              <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-50" data-id="element-165"></div>
              <div className="flex flex-wrap gap-2 mb-6 relative z-10" data-id="element-166">
                {study.tags.map((tag, tagIndex) => <span key={tagIndex} className="px-4 py-2 bg-white/20 backdrop-blur-sm text-white rounded-full text-sm font-medium" data-id="element-167">
                    {tag.name}
                  </span>)}
              </div>
              <div className="relative z-10 mt-6 bg-black/80 backdrop-blur-sm rounded-2xl overflow-hidden p-5 w-[90%] mx-auto shadow-xl" data-id="element-168">
                <img src={study.image} alt={study.title} className="w-full h-56 object-cover rounded-xl" loading="lazy" data-id="element-169" />
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6 z-10" data-id="element-170">
                <div className="flex justify-between items-center" data-id="element-171">
                  <div data-id="element-172">
                    <h3 className="text-2xl font-bold text-white mb-2" data-id="element-173">
                      {study.title}
                    </h3>
                    <p className="text-white/90" data-id="element-174">{study.description}</p>
                  </div>
                  <div className="bg-white/20 backdrop-blur-sm p-3 rounded-full" data-id="element-175">
                    <ArrowRightIcon size={20} className="text-white" data-id="element-176" />
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};